module.exports = __webpack_public_path__ + "img/3.ebd9b708.png";